import DeviceHubIcon from '@material-ui/icons/DeviceHub';
import {
  createFrontendPlugin,
  createRouteRef,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';

const rootRouteRef = createRouteRef();

const ecosystemMapPage = PageBlueprint.make({
  params: {
    path: '/mapa-ecossistema',
    routeRef: rootRouteRef,
    loader: () =>
      import('./EcosystemMapPage').then(module => <module.EcosystemMapPage />),
  },
});

export const ecosystemMapPlugin = createFrontendPlugin({
  pluginId: 'ecosystem-map',
  title: 'Mapa do Ecossistema',
  icon: <DeviceHubIcon />,
  routes: { root: rootRouteRef },
  extensions: [ecosystemMapPage],
});
